(ns dashboard.ui
  "Common events to change UI state"
  (:require [re-frame.core :as rf]))

(rf/reg-event-db
  ::toggle-menu
  (fn [db _]
    (update-in db [:ui :show-menu?] not)))

(rf/reg-event-db
  ::close-menu
  (fn [db _]
    (assoc-in db [:ui :show-menu?] false)))

(rf/reg-event-db
  ::clear-error
  (fn [db [_ _]]
    (assoc-in db [:ui :error] nil)))

(rf/reg-event-db
  ::set-error
  (fn [db [_ error]]
    (assoc-in db [:ui :error] (if-let [message (or (-> error :response :message)
                                                   (:message error)
                                                   (:status-text error))]
                                message
                                error))))

(rf/reg-event-db
  ::push-modal
  (fn [db [_ {:keys [component ctx on-close content-props keybinding-overrides]}]]
    (update-in db [:ui :modal] conj {:component component
                                     :on-close on-close
                                     :ctx ctx
                                     :content-props content-props
                                     :keybinding-overrides keybinding-overrides})))

(rf/reg-event-db
  ::pop-modal
  (fn [db _]
    (update-in db [:ui :modal] rest)))
